// noinspection JSUnresolvedVariable

import {useShowMenu, useShowUI} from "../../services/common";
import {Button, Container, Row} from "./index";
import LogoImage from '../../../images/logo.png';
import SettingIcon from '../../../images/Setting_Dropdown.png';
import LogoutIcon from '../../../images/icon_logout.png';
import {useProfile} from "../../contexts/ProfileContext";
import {useOktaAuth} from "@okta/okta-react";
import SettingMenu, {SettingsMenuItem} from "./SettingMenu";
import {useState} from "react";
import {useHistory, useLocation} from "react-router-dom";
import {clearAllSessions} from "../../services/api/sessionApi";
import {useFactors} from "../../contexts/FactorsContext";

const Header = () => {
	const location = useLocation();
	const history = useHistory();
	const showUi = useShowUI();
	const showMenu = useShowMenu();
	const profileContext = useProfile();
	const {oktaAuth, authState} = useOktaAuth();
	const [menuRef, setMenuRef] = useState();
	const {data} = useFactors();
	const factors = data?.factors;
	const securityQuestionExists = factors ? factors.filter(x => x.type === "question").length > 0 : false;

	if(!showUi) {
		return null;
	}

	const onClickMenu = (event) => setMenuRef(menuRef ? null : event.currentTarget);

	const onCloseMenu = () => setMenuRef(null);

	const onNav = (path) => {
		onCloseMenu();
		history.push(path);
	}

	// const toUserAppPage = () => {
	// 	window.location.href = 'https://authtest.csc.cityu.edu.hk/app/UserHome';
	// }

	const logout = async () => {
		if(authState?.isAuthenticated) {
			await clearAllSessions()
			// await oktaAuth.session.close();
			oktaAuth.tokenManager.clear();
			// oktaAuth.tokenManager.clear();
			// await oktaAuth.signOut('/');
			// await oktaAuth.closeSession();

			// history.replace(toRelativeUrl('/', window.location.origin));

			window.location.href = window.location.origin;
		}
	};

	return (
		<>
		<div className={"header"}>
			<Container>
				<Row>
					<div className={'col-4'}>
						<img src={LogoImage} className={'logo'} alt={'City University'}/>
					</div>
					<div className={'col-8 clearfix'}>
						{showMenu && (
						<ul className={'clearfix'}>
							<li>
								<Button onClick={() => onNav('/')}>
									<div className={'user'}>
										&nbsp;
										{profileContext?.data && (`${profileContext?.data?.firstName} ${profileContext?.data?.lastName}`)}
									</div>
								</Button>
							</li>
							<li onClick={(e) => e.stopPropagation()}>
								<Button onClick={(event) => onClickMenu(event)}>
									<img src={SettingIcon} alt={'Menu'} />
								</Button>
								<SettingMenu isShow={!!menuRef} menuRef={menuRef} onClose={() => onCloseMenu()}>
									<SettingsMenuItem label={'Profile'} onClick={() => onNav('/profile/details')} isActive={location.pathname === '/profile/details'}/>
									<SettingsMenuItem label={'Change Password'} onClick={() => onNav('/profile/password')} isActive={location.pathname === '/profile/password'}/>
									<SettingsMenuItem label={'Set up MFA'} onClick={() => onNav('/profile/mfa')} isActive={location.pathname === '/profile/mfa'}/>
									<SettingsMenuItem label={'Set up Security Questions'} onClick={() => onNav('/profile/question')} isActive={location.pathname === '/profile/question'} notShow={!securityQuestionExists}/>
									<SettingsMenuItem label={'Previous Login'} onClick={() => onNav('/profile/login')} isActive={location.pathname === '/profile/login'}/>
								</SettingMenu>
							</li>
							<li><Button onClick={() => logout()}><img src={LogoutIcon} alt={'Logout'} /></Button></li>
						</ul>
						)}
					</div>
				</Row>
			</Container>
		</div>
		</>
	);
}

export default Header;
